export default "/images/vendor/flag-icons/flags/1x1/pc.svg?1fac77482d005e8e85e42766155d027d";